
document.addEventListener("DOMContentLoaded", function () {
    overwriteAddToCart();
});

const overwriteAddToCart = () => {
    const { ADD_TO_CART } = SMCart.DEFAULT_ACTIONS;

    // We'll make it so that we update things in the cart before actually adding them
    SMCart.clearReducers(ADD_TO_CART);
    SMCart.registerReducer(ADD_TO_CART, updateLineItemsQtyBasedOnVariant);
    SMCart.registerReducer(ADD_TO_CART, addToCartReducerFactory); // Taken from SMCart
}

/**
 * Note that reducers passed are higher order functions. 
 * They are factories of functions to give us the opportunity to inspect the cart if needed
 */
const updateLineItemsQtyBasedOnVariant = (SMCartInstance) => (input) => {
    const items = input.items.map(item => {
        let { quantity, Size: size } = item;
        // TODO: get this from configuration later
        if (size === "Pack") {
            quantity = 12 * quantity;
        }

        if (size === "Case") {
            quantity = 24 * quantity;
        }

        return {
            ...item,
            properties: {
                size: size,
            },
            //  always reverts back to bottle, we move the variant selected to line item properties
            Size: "Bottle",
            quantity
        }
    });

    return {
        ...input,
        items
    }
};